import React, { useEffect, useRef } from "react";

const VideoPlayer = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.currentTime = 0.7;
    }
  }, []);

  return (
    <div>
      <video ref={videoRef} controls width='100%'>
        <source src='https://presale.aitellit.com/aitellit_pre_sale_test_1.mp4' type='video/mp4' />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;
